import type { Dispatch, SetStateAction } from "react";
import { createContext, use } from "react";
import type { AnyRecord } from "@entrilia/shared/types";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { FilterState } from "./filterState";
import type { SelectOption } from "./filterTypes";

export interface Props<R extends AnyRecord> {
  filterState: FilterState<R>;
  setFilterState: Dispatch<SetStateAction<FilterState<R>>>;
  allRowsForSelectOptions?: R[];
  getSelectOptionsForFilter?: (filterId: string) => Promise<SelectOption[]>;
}

interface ContextValue<R extends AnyRecord> extends Props<R> {
  getAsyncSelectOptions: (filterId: string) => Promise<SelectOption[]>;
}

export const FilterContext = createContext<ContextValue<AnyRecord> | undefined>(undefined);

export const useFilterContext = <R extends AnyRecord>() =>
  defined(
    use<ContextValue<R>>(FilterContext as React.Context<ContextValue<R>>),
    "Attempt to use FilterContext without provider"
  );
